import { motion } from "framer-motion";
import "./CoachingInfo.css";
import { Link } from "react-router-dom";

export default function CoachingInfo() {
  return (
    <motion.section
      className="coaching-info"
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <h2 className="headline">
        Smash Your Limits — Choose the Coaching Style That Fits You
      </h2>

      <p className="intro">
        Whether you're chasing your first perfect rally or polishing that jump
        smash,
        <strong> SmashKaro Badminton </strong> offers tailored training that
        matches your ambition, your pace, and your goals. Every session is
        packed with energy, precision, and the guidance of a passionate coach
        who’s committed to helping you level up your game.
      </p>

      <div className="pricing-grid">
        {/* --- INDIVIDUAL COACHING CARD --- */}
        <div className="card">
          <h3> Individual Coaching</h3>
          <p className="price">
            $45<span>/hour</span>
          </p>
          <p className="deal">
            <strong>First session 25% off!</strong> Perfect if you’re serious
            about personalized technique refinement, footwork mastery, or
            strategic play improvement.
          </p>
          <p>
            Work one-on-one with your coach on everything from stroke
            consistency to match strategy. Every move is analyzed and improved
            for maximum precision.
          </p>
          {/* ✅ Redirects to Availability Form */}
          <Link to="/availability" className="hero-btn">
            Book your first session
          </Link>
        </div>

        {/* --- GROUP COACHING CARD --- */}
        <div className="card">
          <h3> Group Coaching</h3>
          <p className="price">
            $35<span>/person</span>
          </p>
          <p className="deal">
            Train together, grow together — ideal for friends, colleagues, or
            players who love a friendly challenge.
          </p>
          <p>
            Group sessions blend fun and competition while focusing on teamwork,
            endurance, and tactical drills. Perfect for all levels looking to
            share the court energy.
          </p>
          {/* ✅ Redirects to Availability Form */}
          <Link to="/availability" className="hero-btn">
            Join a group session
          </Link>
        </div>
      </div>

      <div className="bonus">
        <h4> Loyalty Bonus: SmashKaro 7+1 Deal</h4>
        <p>
          Complete <strong>7 sessions</strong> — and your{" "}
          <strong>next one’s on us!</strong>
          Because progress deserves to be rewarded. Stay consistent, stay sharp,
          and we’ll keep fueling your game.
        </p>
      </div>
    </motion.section>
  );
}
